import { Popper, PopperProps, Typography } from "@mui/material";
import { useAxisTooltip, UseAxisTooltipReturnValue } from "@mui/x-charts";
import {
    generateVirtualElement,
    useMouseTracker,
} from "@mui/x-charts/ChartsTooltip/utils";
import { isNumber } from "lodash";

import { S } from "../reduction-analysis.styles";

export const ChartTooltip = (props: PopperProps) => {
    const tooltipData: UseAxisTooltipReturnValue<"line", Date> | null =
        useAxisTooltip() as any; // Get the tooltip data from the chart.
    const mousePosition = useMouseTracker(); // Track the mouse position on chart.

    if (!tooltipData || !mousePosition) {
        return null;
    }

    const { axisValue, seriesItems } = tooltipData;

    if (!axisValue || !seriesItems) {
        return null;
    }

    let intensity = seriesItems.find((item) => item.seriesId === "intensity");
    let projected = seriesItems.find((item) => item.seriesId === "projected");
    const difference = seriesItems.find((item) => item.seriesId === "diff");

    if (difference && isNumber(difference?.value)) {
        projected = {
            ...projected,
            formattedValue: intensity?.value
                ? intensity?.formattedValue
                : projected?.formattedValue,
        } as any;

        const unit = intensity?.formattedValue?.split(" ") ?? [];
        unit.shift();
        intensity = {
            ...intensity,
            formattedValue:
                intensity?.value && difference.value - intensity.value !== 0
                    ? (intensity.value - (difference.value || 0))
                          .toFixed(2)
                          .toString() +
                      " " +
                      unit.join(" ")
                    : "-",
        } as any;
    }

    const values = [
        { label: intensity?.formattedLabel, value: intensity?.formattedValue },
        { label: projected?.formattedLabel, value: projected?.formattedValue },
    ];

    return (
        <Popper
            {...props}
            sx={{
                pointerEvents: "none",
                zIndex: (theme) => theme.zIndex.modal,
            }}
            placement="bottom"
            anchorEl={generateVirtualElement(mousePosition)}
        >
            <S.TooltipPaper>
                <Typography color="primary" fontWeight="bold" mb={2}>
                    {axisValue.getFullYear()}
                </Typography>

                {values.map((item, index) => (
                    <S.TooltipItem key={index}>
                        <Typography minWidth={100}>{item.label}</Typography>
                        <Typography>{item.value}</Typography>
                    </S.TooltipItem>
                ))}
            </S.TooltipPaper>
        </Popper>
    );
};
